import { Button } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { FileAddOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';

const Style = styled.div`
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
  text-align: center;

  .section {
    display: flex;
    justify-content: center;

    label {
      font-size: var(--size);
      color: #595959;
      font-weight: 500;
    }

    .ant-btn {
      svg {
        margin-top: -4px;
      }
    }

    &.buttons {
      flex-direction: column;
      gap: 8px;

      .ant-btn {
        border: 1px solid var(--color-primary-70);
      }
    }

    a {
      display: flex;

      .ant-btn { 
        flex: 1;
      }
    }
  }

  &.gallery {
    height: 310px;
    background: #FAFAFA;
  }

  &.documents {
    flex: 1;
  }

  &.all {
    flex: 1;
  }
`;

const Empty = ({
  t,
  type = 'GALLERY',
  editUrl = '',
  isOwnData = false,
}) => {
  const isGallery = type === 'GALLERY';
  const isDocuments = type === 'DOCUMENTS';
  const isAll = type === 'ALL';

  const getText = () => {
    if (isGallery) {
      return 'There are no images related to the mine site'
    } else if (isDocuments) {
      return 'There are no documents or links related to this mine site.';
    } else if (isAll) {
      return 'No available documentation.';
    }
    return '';
  };

  const getButtons = () => {
    if (isGallery) {
      return (
        <div className="section">
          <a href={editUrl} target="_blank" rel="noopener noreferrer" >
            <Button
              icon={<FileAddOutlined />}
              type="primary"
            >
              {t('Upload an image')}
            </Button>
          </a>
        </div>
      );
    } else if (isDocuments) {
      return (
        <div className="section">
          <a href={editUrl} target="_blank" rel="noopener noreferrer" >
            <Button
              icon={<PlusCircleOutlined />}
              type="primary"
            >
              {t('Add a document')}
            </Button>
          </a>
        </div>
      );
    } else if (isAll) {
      return (
        <div className="section buttons">
          <a href={editUrl} target="_blank" rel="noopener noreferrer" >
            <Button
              icon={<PlusCircleOutlined />}
              type="primary"
            >
              {t('Add a document')}
            </Button>
          </a>
          <a href={editUrl} target="_blank" rel="noopener noreferrer" >
            <Button
              icon={<FileAddOutlined />}
              type="link"
            >
              {t('Upload an image')}
            </Button>
          </a>
        </div>
      );
    }
    return null;
  }

  return (
    <Style className={formatClassname([
      isGallery && 'gallery',
      isDocuments && 'documents',
      isAll && 'all',
    ])}>
      <div className="section">
        <img src="/assets/images/dashboard/scl-icons/empty-gallery.svg" alt="Empty" />
      </div>
      <div className="section">
        <label>
          {t(getText())}
        </label>
      </div>
      {isOwnData ? getButtons() : null}
    </Style>
  )
};

export default Empty;
